import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./SoftwareCoreServices.css"

import mobileImg from "../../assests/softwareMoblie-img.svg"; 
import webImg from "../../assests/BusinessAnalysis.svg";
import gameImg from "../../assests/ProjectManagement.svg"; 
import Governance from "../../assests/EnterpriseSolution.svg"; 

const SoftwareCoreServices = () => {
  return (
    <div style={{display:"flex",justifyContent:"center"}}>
    <div className="py-5 software-container">
      <h2 className="text-center mb-1 software-h2">Performance & Innovation at Scale</h2>
      <p className="text-center performance-p-core mb-5">Accelerate development | Improve quality | Deliver faster</p>
<Row className="g-4 custom-row ">
  {/* Mobile Applications */}
  <Col md={6} className="custom-col col-5-5">
    <Card className="h-100 card-body-1 " style={{ backgroundColor: "#E0E3FF" }}>
      <Card.Body >
        <Card.Title className=" software-heading">Software Development & Testing</Card.Title>
        <ul className="software-ul card-body-padding">
          <li>Deliver <span className="bold-span">scalable web, mobile, and enterprise applications</span> with modern tech stacks. </li>
          <li>Conduct <span className="bold-span">rigorous testing and QA</span> to ensure high-performance and reliability. </li>
          {/* <li>Enhanced engagement through push notifications, personalized offers, and in-app experiences.</li>
          <li><span className="bold-span">Modern UI/UX design</span> for smooth navigation, superior aesthetics, and outstanding usability.</li> */}
        </ul>
      </Card.Body>
      <div>
        <Card.Img variant="bottom" src={mobileImg} className="mt-3 card-img"  />
      </div>
    </Card>
  </Col>

  {/* Web + Game */}
<Col md={6} className="custom-col">
  <Card
    className="card-web h-50"
    style={{
      backgroundColor: "#FFF9E5",
      display: "flex",
      flexDirection: "column",
      // maxHeight: "285px", 
      marginBottom:"25px"  // 👈 set max height
    }}
  >
     <Card.Title className=" software-heading-1">Business Analysis & Solution Design </Card.Title>
     <div className="ul-and-img" >
    <Card.Body className="card-body-padding">
     
      <ul className="software-ul">
        <li>Translate <span className="bold-span">business requirements into optimized technical solutions.</span> </li>
        <li>Streamline processes with <span className="bold-span">strategic solution design</span> that enhances ROI. </li>
        {/* <li>Focus on fast, reliable performance and <span className="bold-span">smooth user experience</span>.</li>
        <li>Provide end-to-end support from <span className="bold-span">development to deployment</span>.</li> */}
      </ul>
    </Card.Body>
    <div
      style={{ height: "100%", display: "flex", alignItems: "flex-end" }}
      className="card-img"
    >
      <Card.Img variant="bottom" src={webImg} className="software-img" />
    </div>
    </div>
  </Card>

  <Card
    className="card-game h-50"
    style={{
      backgroundColor: "#FFEDE3",
      display: "flex",
      flexDirection: "column",
      // maxHeight: "285px",   // 👈 set max height
    }}
  >
    <Card.Title className=" software-heading-1">Project Management & Delivery </Card.Title>
     <div className="ul-and-img" >
    <Card.Body className="card-body-padding">
      
      <ul className="software-ul">
        <li>
          Manage technology projects with <span className="bold-span">agile and hybrid methodologies</span> for timely delivery
        </li>
        <li>
          Ensure project <span className="bold-span">budget compliance, risk mitigation, and quality assurance.</span> 
        </li>
        {/* <li>High-quality graphics, engaging stories, and smooth gameplay.</li>
        <li><span className="bold-span">Gamified business solutions </span>with interactive rewards.</li> */}
      </ul>
    </Card.Body>
    <div
      style={{ height: "100%", display: "flex", alignItems: "flex-end" }}
      className="card-img"
    >
        <Card.Img variant="bottom" src={gameImg} className="mt-3 software-img" />
      </div>
      </div>
    </Card>
  </Col>

</Row>

        <Row className="align-items-center mt-4 flex-md-row-reverse  card-img-12 card-core-padding">
          <Col md={7} xs={12}>
            <div className="p-4  h-100 text-start ai-text-core">
              <h4 className=" mb-4 corecore-h4">Enterprise Solution Architecture  </h4>
              <ul className="mb-0 corecore-ul">
                <li>
                  Design <span className="bold-span">robust, scalable, and future-proof architectures </span>aligned with business strategy. 
                </li>
                <li>
                  Optimize <span className="bold-span">system interoperability, performance, and maintainability</span> for long-term growth.  
                </li>
                {/* <li>
                  Complete visibility with data lineage tracking and audit trails. 
                </li>
                <li>
                Automated compliance reporting to <span className="bold-span">reduce manual work</span>.
                </li> */}
              </ul>
            </div>
          </Col>
          <Col md={5} xs={12} className="text-start mt-3 mt-md-0">
            <img
              src={Governance}
              alt="Robotics Solutions"
              className="img-fluid"
            />
          </Col>
        </Row>

    </div>
    </div>
  );
};

export default SoftwareCoreServices;
